<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-image card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      
      <div class="card-data-media" v-if="node.data.carouselItemTitle">
        <div class="card mb-2" v-if="node.data.file">
          <img class="card-img-top" :src="node.data.file"/>
          <div class="card-body p-2">
            <h5 class="card-title mb-0" v-if="node.data.carouselItemTitle">{{ node.data.carouselItemTitle }}</h5>
            <p class="card-text text-muted mt-0 mb-2" v-if="node.data.carouselItemSubtitle">{{ node.data.carouselItemSubtitle }}</p>
            <a :href="node.data.imageClickDestinationLink" class="btn btn-sm btn-outline-primary card-image-link" v-if="node.data.imageClickDestinationLink">{{ node.data.imageClickDestinationLink }}</a>
          </div>
        </div>
      </div>
      <div v-else class="double-click-div text-center">
        <img :src="icon_doubletap" :title="double_click_for_settings">
      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { templateComponentMethods } from '../../utils/functions'
import { lang } from '../../assets/lang'

export default {
  name: 'CarouselSingleTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    baseUrl: window.xitFlowBuilderData.base_url,
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,
  }),

  methods: {
    ...templateComponentMethods,
  }
}
</script>